import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import Seperator from '../component/seperator'

import { successMessage } from "../utils/toastMessage"
import PageUrlGuid from '../component/pageUrlGuid'
import { conference } from '../service/journalService'


const Conference = () => {
    const [getBlog, setBlog] = useState({})
    const [getTags, setTags] = useState([])
    const navigate = useNavigate();
    const slug = useParams().slug

    const handleGetBlog = async (slug) => {
        try {
            const { status, data } = await conference(slug);
            if (status === 200) {
                setBlog(data.blog)
                setTags(data.tags)
                document.getElementById("description").innerHTML=data.blog.description
            }
        }
        catch (ex) {
            // navigate("/notFound")
        }


    }



    const handleCopyToClipboard = () => {
        var el = document.querySelector(".shortcut>.short-link").innerHTML
        navigator.clipboard.writeText(el);
        successMessage("لینک کپی شد")
    }

    useEffect(() => {
        handleGetBlog(slug)
    }, [])
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <Link to={"/conferences"}>
                    همایش ها
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getBlog.title}
                </h1>
            </PageUrlGuid>
            <div className='singleBlog'>
                <div className='content-container'>
                    <div className='content'>
                        <img src={getBlog.image} alt={getBlog.title} />
                        <h2 className='title'>{getBlog.title}</h2>
                        <div className='description' id='description'></div>
                    </div>
                    <div className='social-shortcut'>
                        <div className='social'>
                            <span className='title'>اشتراک گذاری :</span>
                            <div className='icons'>
                                {/* <Link className='link'>
                                    <img className='instagram-icon' src="http://localhost:8000/media/socialMedia/instagram.png" alt="" />
                                </Link> */}
                                <a className='link' href={`whatsapp://send?text=${window.location.href}`}>
                                    <img className='whatsapp-icon' src={`https://dl.newwebinar.ir/base/whatsapp.png`} alt="" />
                                </a>
                                <a className='link' href={`https://t.me/share/url?url=${window.location.href}`}>
                                    <img className='telegram-icon' src={`https://dl.newwebinar.ir/base/telegram.png`} alt="" />
                                </a>
                            </div>
                        </div>
                        <div className='shortcut' onClick={handleCopyToClipboard}>
                            <span>لینک کوتاه :</span>
                            <span className='short-link'>{`https://www.newwebinar.ir/s/0${getBlog.id}`}</span>
                            <i className='fas fa-copy'></i>
                        </div>
                    </div>
                    <div className='tags'>
                        <div className='title'>
                            <i className='fa fa-tags'></i>
                            <h2>برچسب ها</h2>
                        </div>
                        <div className='tags-content'>
                            {getTags.map(tag => (
                                <Link to={`/conferences?page=1&filter=id&search=${tag.title}&category=`} key={tag.id} className='tag'>{tag.title}</Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Conference